// eslint-disable-next-line import/no-extraneous-dependencies
import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@digital-hig/mui/dist/Typography';
import { Link } from 'react-router-dom';
import Button from '@mui/material/Button';
import CardActions from '@mui/material/CardActions';
import SvgIcon from '@mui/material/SvgIcon';
import Card from '@mui/material/Card';
import SvgCtaArrowRight from '@digital-hig/icon/lib/esm/icons/cta-arrow-right';
import styled from 'styled-components';
import ProductIcons from './productIcons';
import { triggerManualLinkClick } from '../common/analyticsApi';

const GettingStartedPanelCard = ({
  title, shortDescription, viewQuickGuideUrl, products, singleDisplay,
}) => (
  <RootElement>
    <Card
      className="get-started-panel-single-card"
      quiet={singleDisplay}
    >
      <div>
        <div className="logo-wrapper">
          <ProductIcons products={products} />
        </div>
        <div className="title-description">
          <Typography component="span" variant="headline-small">{title}</Typography>
          <Typography component="span" variant="body-copy-medium">{shortDescription}</Typography>
        </div>
      </div>
      <CardActions
        className="carouselGroupButton"
        id="view-quick-guide-link"
      >
        <Button
          variant="link-button"
          startIcon={<SvgIcon><SvgCtaArrowRight /></SvgIcon>}
          component={Link}
          to={viewQuickGuideUrl}
          onClick={() => triggerManualLinkClick({ linkTitle: `View the quick start guide for ${products?.map((p) => p?.displayName).join(', ')}` })}
        >
          View the quick start guide
        </Button>
      </CardActions>
    </Card>
  </RootElement>
);

const RootElement = styled.div`
  display: flex;
  flex-direction: row;
  gap: 24px;
  
  .get-started-panel-single-card {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    border-radius: 8px;

    .logo-wrapper {
       padding: 16px;
       padding-left: 20px;
    }

      .title-description {
        display: flex;
        flex-direction: column;
        gap: 8px;
        padding: 24px;
        padding-top: 20px;
      }

      #view-quick-guide-link {
        padding-top: 16px;
        padding-bottom: 22px;
        padding-left: 24px;
        padding-right: 24px;
      }
  }
`;

GettingStartedPanelCard.propTypes = {
  title: PropTypes.string.isRequired,
  singleDisplay: PropTypes.bool,
  products: PropTypes.oneOfType([PropTypes.array]),
  shortDescription: PropTypes.string.isRequired,
  viewQuickGuideUrl: PropTypes.string.isRequired,
};

GettingStartedPanelCard.defaultProps = {
  singleDisplay: false,
  products: [],
};

export default GettingStartedPanelCard;
